module.exports = __webpack_public_path__ + "static/media/as_rule.0d89645e.png";